import React, { useState, useEffect } from 'react';
import ConfirmationWindow from '../common/ConfirmationWindow';
import { useSubscription } from '../common/SubscriptionsProvider';
import { useAuth } from '../common/AuthProvider';
import { Form } from 'react-bootstrap';

const UserSubscription = () => {

    const { isAuthenticated } = useAuth();

    const { activePlan, 
        getCurrentSubscription, 
        handleRenewSubscription, 
        handleCancelActiveSubscription
    } = useSubscription();

    const [showModalCancel, setShowModalCancel] = useState(false);
    const [showModalRenew, setShowModalRenew] = useState(false);
    
    // end_date is in the format: YYYY-MM-DD
    const subscriptionExpired = activePlan.end_date !== null 
        && activePlan.end_date !== undefined 
        && new Date(`${activePlan.end_date}T23:59:59`) < new Date();

    useEffect(() => {
        if (isAuthenticated) {
            const fetchSubscription = async () => {
                await getCurrentSubscription();
            };
            fetchSubscription();
        }
    }, [isAuthenticated]);

    return (
            activePlan.canceled ? 
                <>
                <Form.Text className="text-muted">
                    You canceled your current subscription plan <b
                    >{activePlan.plan}</b> on <b>{activePlan.canceled_at}</b>. 
                    The subscription {subscriptionExpired ? 'expired on' : 'is still valid until'} <b
                    >{activePlan.end_date}</b> {subscriptionExpired ? '.' : 
                        'after which you will lose access to your projects.'} You can renew your subscription <span 
                    onClick={() => setShowModalRenew(true)} 
                    className="underlined-text">here</span>.
                </Form.Text> 

                <ConfirmationWindow 
                    body={"Are you sure you want to renew your subscription?"}
                    title={"Renew Subscription"}
                    showModal={showModalRenew} 
                    setShowModal={setShowModalRenew} 
                    handleOnClick={handleRenewSubscription} 
                />
                </>:
            
            (isAuthenticated && activePlan.plan !== null 
                && activePlan.plan !== undefined) ? 
            <>
            <Form.Text className="text-muted">
                Your current subscription plan <b>{activePlan.plan}</b> 
                {subscriptionExpired ? ' expired on' : ' is valid until'} <b
                    >{activePlan.end_date}</b>{activePlan.plan !== 'Free' ? 
                ' after which it will be automatically renewed' : null}. 
                You can {subscriptionExpired ? ' update' : ' cancel'} your 
                subscription {subscriptionExpired ? 'when you prefer.' : <span onClick={() => 
                setShowModalCancel(true)} className="underlined-text">here.</span>}
            </Form.Text> 
            <ConfirmationWindow 
                body={"Are you sure you want to cancel your subscription? This action \
                    cannot be undone. You will lose access to all premium features. Once \
                    canceled, your subscription will continue until the end of the current \
                    billing cycle, after which it will not be renewed."}
                title={"Cancel Subscription"}
                showModal={showModalCancel} 
                setShowModal={setShowModalCancel} 
                handleOnClick={handleCancelActiveSubscription} 
            />
            </> : null
    )
}

export default UserSubscription;
